import React from "react"
import { Spinner } from "../../assets/icons/spinner"

const Button = ({ title, icon, loading, disabled, className, ...rest }) => {
  return (
    <button
      disabled={loading || disabled}
      className={`relative inline-flex justify-center items-center w-full bg-primary px-2 gap-1 h-11 text-white rounded-full ${className} ${
        loading || disabled ? "opacity-70 cursor-not-allowed" : ""
      }`}
      {...rest}>
      <img src={icon} alt="" />
      {title}
      {loading && <Spinner className="absolute right-4 !w-4 !h-4" />}
    </button>
  )
}

export default Button
